import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface ChargeCodeListItem {
  codeDesc: string;
  codeID: string;
}

export const getChargeCodesAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetChargeCode`,
  });
};

export type ChargeCodesResponse = ChargeCodeListItem[];

export const fetchChargeCodes = async (): Promise<ChargeCodesResponse> => {
  const response: AxiosResponse<ChargeCodesResponse> = await getChargeCodesAPI();
  return response.data;
};
